// extracted by mini-css-extract-plugin
export var container = "_a8-0";
export var error = "_a8-9";
export var label = "_a8-5";
export var light = "_a8-6";
export var md = "_a8-3";
export var sm = "_a8-2";
export var thin = "_a8-8";
export var thinBold = "_a8-7";
export var vertical = "_a8-4";
export var xs = "_a8-1";